import { useTranslation } from 'next-i18next';
import { RateSubRates, RateWrapper } from './rate.style';
import React from 'react';
import RateStars from '../RateStars';
import RateItem from '../RateItem';
import Button from 'reusecore/src/elements/Button';
import { MdAddComment } from 'react-icons/md';
import { closeModal, openModal } from '@redq/reuse-modal';
import AddReview from '../../containers/AddReview';
import LoginModal from '../../containers/ModalContainer/LoginModal';
import { useAuth } from '../../contexts/AuthProvider';

const Rate = ({
  global,
  communication,
  punctuality,
  quality,
  uid,
  ...props
}) => {
  const { t } = useTranslation();
  const { isLoggedIn } = useAuth();
  const { handleAddReview } = props;

  const showLoginModal = () =>
    openModal({
      config: {
        disableDragging: false,
        minHeight: 'auto',
        width: 'auto',
        height: 'auto',
        enableResizing: true,
        transition: {
          tension: 150,
        },
      },
      springStyle: {
        backgroundColor: '#ffffff',
        overflowY: 'auto',
      },
      modalClass: 'loginModal',
      closeOnClickOutside: true,
      component: LoginModal,
      componentProps: {},
    });

  const handleModal = () => {
    if (isLoggedIn) {
      let data = {
        data: {
          uid: uid,
          handleAddReview: handleAddReview,
        },
      };
      reviewModal(data);
    } else {
      showLoginModal();
    }
  };

  const reviewModal = newReview => {
    openModal({
      config: {
        disableDragging: false,
        width: 600,
        height: 'auto',
        enableResizing: {
          bottom: true,
          bottomLeft: true,
          bottomRight: true,
          left: true,
          right: true,
          top: true,
          topLeft: true,
          topRight: true,
        },
      },
      springStyle: {
        backgroundColor: '#ffffff',
      },
      closeOnClickOutside: true,
      component: AddReview,
      componentProps: {
        data: {
          closeModal,
          title: t('review.modalAdd.title'),
          uid: newReview.data.uid,
          handleAddReview,
        },
      },
    });
  };

  return (
    <RateWrapper>
      <RateStars value={global} size={'34px'} readOnly />
      <RateSubRates>
        <RateItem value={communication} type={'communication'} />
        <RateItem value={punctuality} type={'punctuality'} />
        <RateItem value={quality} type={'quality'} />
      </RateSubRates>
      <div style={{ textAlign: 'center' }}>
        <Button
          title={t('review.addReview')}
          fontSize={15}
          icon={
            <MdAddComment size={16} color="#fff" style={{ marginRight: 10 }} />
          }
          iconPosition="left"
          className="primary"
          bg="#00BCD4"
          style={{
            fontSize: 15,
            marginBottom: 15,
            width: '100%',
            padding: 15,
            fontWeight: 'bold',
          }}
          onClick={handleModal}
        />

        <span>{t('review.addReviewDesc')}</span>
      </div>
    </RateWrapper>
  );
};

export default Rate;
